import html2canvas from 'html2canvas';

export const useScreenshot = () => {
    const handleClickTakeScreenShot = (
        currentRef: HTMLDivElement | null,
        additionalElements: string[],
        fileName?: string,
    ) => {
        const defaultElements = [
            { name: 'download-icon', display: 'none' },
            { name: 'learn-more', display: 'none' },
            { name: 'screenshotFooter', display: 'flex' },
            { name: 'screenshotHeader', display: 'flex' },
            ...additionalElements.map((el: any) => ({ name: el, display: 'none' })),
        ];

        const title = document.getElementById('title');
        const footer = document.getElementById('footer');

        title!.style.backgroundColor = 'white';
        footer!.style.display = 'none';

        const elements = defaultElements.reduce(
            (acc: any, el: any) => [
                ...acc,
                { name: document.getElementById(el.name), display: el.display },
            ],
            [],
        );

        elements.map((el: any) => (el.name.style.display = el.display));

        const devicePixelRatio = window.devicePixelRatio;
        const maxWidth = window.innerWidth >= 1976 ? 1976 : window.innerWidth;
        const currentWidth = maxWidth * devicePixelRatio;
        const currentHeight = document.body.scrollHeight * devicePixelRatio;
        const { cropPositionTop, cropPositionLeft, cropWidth, cropHeigth } = {
            cropPositionTop: 0,
            cropPositionLeft: 0,
            cropWidth: currentWidth,
            cropHeigth: currentHeight,
        };

        function downloadScreenshot(canvas: HTMLCanvasElement) {
            let croppedCanvas = document.createElement('canvas');
            let croppedCanvasContext = croppedCanvas.getContext('2d');
            croppedCanvas.width = cropWidth;
            croppedCanvas.height = cropHeigth;
            croppedCanvasContext!.drawImage(canvas, cropPositionLeft, cropPositionTop);
            const a = document.createElement('a');
            a.href = croppedCanvas.toDataURL();
            a.download = `${fileName}.png`;
            a.click();
        }

        currentRef && html2canvas(currentRef).then((canvas) => downloadScreenshot(canvas));
        title!.style.backgroundColor = '#F5F5F5';
        footer!.style.display = 'flex';
        elements.map(
            (el: any) => (el.name.style.display = el.display === 'none' ? 'block' : 'none'),
        );
    };

    return { handleClickTakeScreenShot };
};
